export const formatPayeeInfo = (value) => {
  if (value === undefined || value === null || value === '') {
    return '-';
  }
  if (typeof value === 'object') {
    return value.name ? String(value.name) : '-';
  }
  const serializedPayee = String(value);
  if (!serializedPayee.startsWith('{')) {
    return value;
  }
  try {
    const payee = JSON.parse(serializedPayee);
    return payee?.name ? String(payee.name) : '-';
  } catch {
    return value;
  }
};
